import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Sidebar from "./Sidebar";
import TopBarIcons from "./TopBarIcons";
import "../css/requisition-app-styles.css";
import { Link } from "react-router-dom";
import PopupModal from "./PopupModal";
import { faCheckCircle, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import LoadingOverlay from "./LoadingOverlay";
import { faWifi } from '@fortawesome/free-solid-svg-icons';
    


const AddUser = () => {
  const [showModal, setShowModal] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  
  
  const [displayPictureDataUrl, setDisplayPictureDataUrl] = useState("");
  const [signaturePreview, setSignaturePreview] = useState(null);
  const [displayPicturePreview, setDisplayPicturePreview] = useState(null);

  const handleModalClose = () => {
        
    window.location.reload();
  };
  const handleErrorModalClose = () => {
    setShowErrorModal(false);
  };

  const handleDisplayPictureChange = (e) => {
    const file = e.target.files[0];
    if (file && file.type.startsWith("image/")) {
      const img = new Image();
      const reader = new FileReader();
  
      reader.onload = () => {
        img.src = reader.result;
      };
  
      reader.readAsDataURL(file);
  
      img.onload = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
  
        const maxWidth = 400;
        const maxHeight = 400;
        let width = img.width;
        let height = img.height;
  
        if (width > height) {
          if (width > maxWidth) {
            height *= maxWidth / width;
            width = maxWidth;
          }
        } else {
          if (height > maxHeight) {
            width *= maxHeight / height;
            height = maxHeight;
          }
        }
  
        canvas.width = width;
        canvas.height = height;
        ctx.drawImage(img, 0, 0, width, height);
  
        const dataUrl = canvas.toDataURL("image/jpeg", 0.5);
        setDisplayPictureDataUrl(dataUrl);
      };
    } else {
      alert("Please upload a valid image file.");
    }
  };
  
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    userName: "",
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    position: "",
    staffLevel: "",
    supervisorName: "",
    userType: "",
    password: "",
  });

  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const theUserType = localStorage.getItem("userType");

  const handleChange = (e) => {
    const { name, value } = e.target;
  
    setFormData((prevData) => ({
      ...prevData,
      [name]: name === "reviewerNumber" ? parseInt(value) || null : value,
    }));
  };


  const handleSubmit = async (e) => {
    setIsSubmitting(true);
  try{
    e.preventDefault();
  
    const fullPayload = {
      ...formData,
      signature: formData.signature, 
      displayPicture: displayPictureDataUrl, 
    };
  
    console.log("Submitting payload:", fullPayload); 
  
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/users`, fullPayload);
  
      if (response.status === 200) {
        setShowModal(true);
      }
    } catch (error) {
      setShowErrorModal(true);
      console.error("Axios error object:", error);
    
      if (error.response) {
        const validationErrors = error.response.data?.errors;
        let messages = [];
    
        if (validationErrors && typeof validationErrors === 'object') {
          for (const key in validationErrors) {
            const fieldErrors = validationErrors[key];
            if (Array.isArray(fieldErrors)) {
              messages.push(`${key}: ${fieldErrors.join(", ")}`);
            } else if (typeof fieldErrors === 'string') {
              messages.push(`${key}: ${fieldErrors}`);
            }
          }
    
          setErrorMessage(messages.join("\n"));
        } else {
          setShowErrorModal(true);
          setErrorMessage(error.response.data?.message || "Sorry. Failed to add user.");
        }
    
        console.error("Status Code:", error.response.status);
        console.error("Headers:", error.response.headers);
      } else if (error.request) {
        console.error("No Response Received:", error.request);
        setErrorMessage("No response from the server. Please try again later.");
      } else {
        console.error("Error Setting Up Request:", error.message);
        setErrorMessage("An unexpected error occurred. Please try again.");
      }
    
      setSuccessMessage("");
    }
  } finally {
    setIsSubmitting(false);
  }   
  };
    
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    const field = e.target.name; 
  
    if (!file || !file.type.startsWith("image/")) {
      alert("Please upload a valid image file.");
      return;
    }
  
    const img = new Image();
    const reader = new FileReader();
  
    reader.onload = () => {
      img.src = reader.result;
  
      if (field === "displayPicture") {
        setDisplayPicturePreview(reader.result);
      }
     else if (field === "signature") {
      setSignaturePreview(reader.result);
      }
    };
  
    reader.readAsDataURL(file);
  
    img.onload = () => {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
  
      let width = img.width;
      let height = img.height;
      const maxWidth = 400;
      const maxHeight = 400;
  
      if (width > height) {
        if (width > maxWidth) {
          height *= maxWidth / width;
          width = maxWidth;
        }
      } else {
        if (height > maxHeight) {
          width *= maxHeight / height;
          height = maxHeight;
        }
      }
  
      canvas.width = width;
      canvas.height = height;
      ctx.drawImage(img, 0, 0, width, height);
  
      const compressedDataUrl = canvas.toDataURL("image/jpeg", 0.5);
  
      if (field === "displayPicture") {
        setDisplayPictureDataUrl(compressedDataUrl); 
        setFormData((prev) => ({
          ...prev,
          displayPicture: compressedDataUrl,
        }));
      } else if (field === "signature") {
        setFormData((prev) => ({
          ...prev,
          signature: compressedDataUrl,
        }));
      }
    };
  };
  
  return (
    <div id="wrapper">
      {/* Sidebar */}
      <Sidebar userType={theUserType} />

      {/* Content Wrapper */}
      <div id="content-wrapper" className="d-flex flex-column">
        {/* Main Content */}
        <div id="content">
          {/* Topbar */}
          <nav className="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow">
            <button
              id="sidebarToggleTop"
              className="btn btn-link d-md-none rounded-circle mr-3"
            >
              <i className="fa fa-bars"></i>
            </button>

            {/* Topbar Navbar */}
            <ul className="navbar-nav ml-auto">
              <TopBarIcons />
            </ul>
          </nav>
          {/* End of Topbar */}

          {/* Begin Page Content */}
          <div className="container-fluid">
          <LoadingOverlay isVisible={isSubmitting} />

            <div className="view-requisition-header">
              <Link className="nav-link" to="/dashboard">
                <i className="fas fa-arrow-left back-button"></i>
              </Link>
              <h1 className="form-heading h3 mb-4 text-gray-800">Add User</h1>
            </div>

            {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}
            {successMessage && (
              <div className="alert alert-success">{successMessage}</div>
            )}

            <div id="add-user-div" className="form-group reduce-width-div">
            <h3>User Details</h3>
            <form onSubmit={handleSubmit}>
                <div className="form-group">
                        <div>
                          <label htmlFor="displayPicture">Display Picture</label>
                          <input
                            type="file"
                            id="displayPicture"
                            name="displayPicture" 
                            className="form-control"
                            accept="image/*"
                            onChange={handleFileChange}
                            required
                        />


                        </div>

                        {displayPictureDataUrl && (
                          <img
                            src={displayPictureDataUrl}
                            alt="Display Picture Preview"
                            className="preview-image"
                          />
                        )}



                        <div>
                        <label htmlFor="firstName">First Name</label>
                        <input
                            type="text"
                            id="firstName"
                            name="firstName"
                            className="form-control"
                            value={formData.firstName}
                            onChange={handleChange}
                            required
                        />
                        </div>
                        <div>
                        <label htmlFor="lastName">Last Name</label>
                        <input
                            type="text"
                            id="lastName"
                            name="lastName"
                            className="form-control"
                            value={formData.lastName}
                            onChange={handleChange}
                            required
                        />
                        </div>
                        <div>
                        <label htmlFor="userName">Username</label>
                        <input
                            type="text"
                            id="userName"
                            name="userName"
                            className="form-control"
                            value={formData.userName}
                            onChange={handleChange}
                            required
                        />
                        </div>
                        <div>
                        <label htmlFor="email">Email</label>
                        <input
                            type="email"
                            id="email"
                            name="email"
                            className="form-control"
                            value={formData.email}
                            onChange={handleChange}
                            required
                        />
                        </div>
                        <div>
                        <label htmlFor="phoneNumber">Phone Number</label>
                        <input
                            type="text"
                            id="phoneNumber"
                            name="phoneNumber"
                            className="form-control"
                            value={formData.phoneNumber}
                            onChange={handleChange}
                            required
                        />
                        </div>
                    </div>
                    <div className="form-group">
                        <div>
                        <label htmlFor="position">Position</label>
                        <input
                            type="text"
                            id="position"
                            name="position"
                            className="form-control"
                            value={formData.position}
                            onChange={handleChange}
                            required
                        />
                        </div>
                        <div>
                        <label htmlFor="staffLevel">Staff Level</label>
                        <input
                            type="text"
                            id="staffLevel"
                            name="staffLevel"
                            className="form-control"
                            value={formData.staffLevel}
                            onChange={handleChange}
                            required
                        />
                        </div>
                        <div>
                        <label htmlFor="supervisorName">Supervisor Name</label>
                        <input
                            type="text"
                            id="supervisorName"
                            name="supervisorName"
                            className="form-control"
                            value={formData.supervisorName}
                            onChange={handleChange}
                            required
                        />
                        </div>
                        <div>
                        <label htmlFor="userType">User Type</label>
                        <select
                            id="userType"
                            name="userType"
                            className="form-control"
                            value={formData.userType}
                            onChange={handleChange}
                            required
                        >
                            <option value="">Select User Type</option>
                            <option value="Requester">Requester</option>
                            <option value="Reviewer">Reviewer</option>
                            <option value="Reviewer">Surrender Reviewer</option>
                            <option value="Administrator">Administrator</option>
                        </select>
                        </div>

                        {formData.userType === 'Reviewer' && (<div>
                          <select
                            name="reviewerNumber"
                            value={formData.reviewerNumber || ''}
                            onChange={handleChange}
                          >
                            <option value="">Select Reviewer Number</option>
                            <option value={1}>1st Reviewer</option>
                            <option value={2}>2nd Reviewer</option>
                            <option value={3}>3rd Reviewer</option>
                          </select>
                          </div>
                        )}

                        <div>
                        <label htmlFor="password">Password</label>
                        <input
                            type="password"
                            id="password"
                            name="password"
                            className="form-control"
                            value={formData.password}
                            onChange={handleChange}
                            required
                        />
                        </div>
                        <div className="form-group">
                        <label htmlFor="signature">Signature</label>
                        <input
                            type="file"
                            id="signature"
                            name="signature"
                            className="form-control"
                            accept="image/*"
                            onChange={handleFileChange}
                            required
                        />
                        </div>
                        {signaturePreview && (
                          <img
                            src={signaturePreview}
                            alt="Signature Preview"
                            className="preview-image"
                          />
                        )}


                    </div>
                <button type="submit" className="btn btn-primary">
                Add User
                </button>
            </form>
            <PopupModal
              title="User Added"
              titleStyle = "success-title"
              message="A user has been added successfully."
              icon={faCheckCircle}
              isVisible={showModal}
              onClose={handleModalClose}
              iconBorder="popup-modal-icon"
            />
                          
            <PopupModal
                title="Error"
                titleStyle = "error-title"
                message="Sorry. Please check your internet connection and try again."
                icon={faTimesCircle}
                iconColor="red"
                isVisible={showErrorModal}
                onClose={handleErrorModalClose}
                iconBorder="x-icon"
              />
            </div>
          </div>
          {/* End of container-fluid */}
        </div>
        {/* End of Main Content */}

        {/* Footer */}
        <footer className="sticky-footer bg-white">
          <div className="container my-auto">
            <div className="copyright text-center my-auto">
              <span>Copyright &copy; Farm Concern Internationalal 2025</span>
            </div>
          </div>
        </footer>
        {/* End of Footer */}
      </div>
    </div>
  );
};

export default AddUser;
